<script>
	import DamageInformationDisplay from "./DamageInformationDisplay.svelte";
	import DamageInformationInput from "./DamageInformationInput.svelte";
	import { caseCreationForm } from "src/validators/CaseCreation";
	import DamageInformationInputDesmond from "./DamageInformationInputDesmond.svelte";
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import { onMount } from "svelte";

	export let caseDetails = {};
	export let state = "view"; // possible values: "view", "edit", "create"
	export let dateReported;
	export let attribution;
	export let damageCause;
	export let damageCauseType;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let incidentDateTime;
	export let vqp;
	export let l1Remarks;

	onMount(() => {
		if (
			(caseDetails.createdFrom === "Operator" &&
				caseDetails.status === "Quoting") ||
			caseDetails.status === "Investigating"
		) {
			state = "create";
		}
	});
</script>

<CustomCollapseCard
	customClass="mb-4"
	title="Damage Information"
	isOpenDefault={true}
>
	{#if state === "create" || state === "edit"}
		{#if caseDetails.createdFrom === "Desmond"}
			<DamageInformationInputDesmond
				{caseDetails}
				{incidentDateTime}
				form={caseCreationForm}
				{state}
				{damageCauseType}
				{attribution}
				{damageCause}
				{staffName}
				{staffContact}
				{thirdPartyName}
				{thirdPartyContact}
				{vqp}
			/>
		{:else}
			<DamageInformationInput
				form={caseCreationForm}
				{dateReported}
				{attribution}
				{damageCause}
				{damageCauseType}
				{staffName}
				{staffContact}
				{thirdPartyName}
				{thirdPartyContact}
				{incidentDateTime}
				{vqp}
				{l1Remarks}
				{caseDetails}
			/>
		{/if}
	{:else if state === "view"}
		<DamageInformationDisplay
			{caseDetails}
			{incidentDateTime}
			form={caseCreationForm}
			{damageCauseType}
			{attribution}
			{damageCause}
			{staffName}
			{staffContact}
			{thirdPartyName}
			{thirdPartyContact}
			{vqp}
			{l1Remarks}
		/>
	{/if}
</CustomCollapseCard>
